<template>
	<div class="container">
		<iframe ref="printFrame" style="display:none;"></iframe>
		<div class="wrap" ref="printContent">
			<div class="header">
				<div class="left">Order No.: {{detail.order_no}}</div>
				<div class="left">Order Time: {{detail.create_time}}</div>
			</div>

			<div class="title">Fabric Details</div>

			<div class="table">
				<div class="item th">
					<div class="alias"></div>
					<div class="info">Product Information</div>
					<div class="width">Width/Weight</div>
					<div class="component">Composition</div>
					<div class="desc">Usage Instructions</div>
					<div class="size">Size</div>
				</div>
				<template  v-for="(m,k) in detail.mtms">
					<div class="item td" v-for="(v,k) in m.design_data.category.material_self" :key="k">
						<div class="alias">{{v.alias}}</div>
						<div class="info">
							<img v-if="v.image" :src="v.image" alt="" class="image">
							<div class="name">{{v.fabric_name_cn}}</div>
						</div>
						<div class="width">
							{{v.width_wide}}
						</div>
						<div class="component">
							{{v.component_en}}
						</div>
						<div class="desc">
							{{v.desc}}
						</div>
						<div class="size">
							{{v.size}}
						</div>
					</div>
				</template>
			</div>
			<p class="tip">Note: Please print out your fabric details and attach it to the outer packaging of the fabric, and send it to the manufacturer along with the fabric, so that we can find your fabric faster among many fabrics and serve you!</p>
			<!-- window.print() -->
			<div class="btn-print" @click="printContainer">Print Fabric Details</div>
		</div>


	</div>

</template>

<script>
	import {
	OrderDetail,
} from "@/api/index.js";
	export default {
		name: 'OrderDetail',
		components: {

		},
		data() {
			return {
				uuid: 0,
				detail: {
					design: {}
				}
			};
		},
		watch: {

		},
		computed: {

		},
		mounted() {
			this.uuid = this.$route.query.uuid
			OrderDetail({uuid: this.uuid}).then(response => {
				this.detail = response.data
			}).catch(err => {
				this.$layer.msg(err.msg)
			})
		},
		methods: {
			printContainer() {
				const content = this.$refs.printContent.innerHTML;
  const frame = document.createElement('iframe');
  frame.style.position = 'absolute';
  frame.style.top = '-9999px';
  frame.style.left = '-9999px';
  document.body.appendChild(frame);

  const doc = frame.contentDocument || frame.contentWindow.document;

  // 写入完整的 HTML + 样式
  doc.open();
  doc.write(`
    <html>
      <head>
        <title>打印面料详情单</title>
        <style lang="scss">
          /* 👇 把你需要的样式直接写在这里 */
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          .container {
            width: 100%;
            max-width: 100%;
            margin: 0 auto;
            background: #fff;
            padding: 40px 70px;
            box-sizing: border-box;
          }

          .wrap {
        //   padding:40px 70px;
		  padding:10px 0;
          background: white;
          border-radius: 10px;
        }

        .wrap .header {
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #000000;
          padding:20px 0;
        }

        .wrap .title {
          font-size: 20px;
          font-weight: bold;
          color: black;
          padding: 10px 0;
          text-align: center;
        }

        .wrap .table {
          margin-top: 10px;
          border-radius: 10px;
          background: white;
        }

        .wrap .table .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #F6F7FA;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #E3E3E3;
          color: #575859;
          font-size: 14px;
        }

        .wrap .table .th .alias {
          width: 190px;
        }

        .wrap .table .th .info {
          width: 480px;
        }

        .wrap .table .th .width {
          width: 190px;
        }

        .wrap .table .th .component {
          width: 190px;
        }

        .wrap .table .th .desc {
          width: 300px;
        }

        .wrap .table .th .size {
          width: 220px;
        }

        .wrap .table .td {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          border: 1px solid #E3E3E3;
        }

        .wrap .table .td .info {
          position: relative;
          width: 480px;
          height: 110px;
          border-right: 1px solid #E3E3E3;
        }

        .wrap .table .td .info .image {
          position: absolute;
          top: 20px;
          left: 20px;
          width: 68px;
          height: 68px;
          object-fit: cover;
        }

        .wrap .table .td .info .name {
          position: absolute;
          top: 34px;
          left: 150px;
          color: #191A1C;
          font-size: 14px;
          font-weight: 500;
        }

        .wrap .table .td .alias {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          align-content: center;
          justify-content: center;
          width: 190px;
          height: 110px;
          border-right: 1px solid #E3E3E3;
        }

        .wrap .table .td .width,
        .wrap .table .td .component,
        .wrap .table .td .desc,
        .wrap .table .td .size {
          width: 190px;
          height: 110px;
          line-height: 110px;
          border-right: 1px solid #E3E3E3;
          font-weight: bold;
          font-size: 14px;
        }

        .wrap .table .td .desc {
          width: 300px;
        }

        .wrap .table .td .size {
          width: 220px;
        }

        .tip {
          color: #FA3D5A;
          padding: 20px 0;
        }

          .btn-print {
            display: none; /* 隐藏打印按钮 */
          }

          @media print {
            body {
              padding: 0;
            }
            .container {
              padding: 20px;
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
			<div class="wrap">
				${content}
			</div>
		</div>
      </body>
    </html>
  `);
  doc.close();

  // 等待文档加载完成再执行打印
  const win = frame.contentWindow;
  win.focus();

  // 延迟执行确保样式渲染完成
  setTimeout(() => {
    win.print();
    // 可选：移除 iframe（避免重复生成）
    setTimeout(() => {
      document.body.removeChild(frame);
    }, 500);
  }, 500);
			}
		},

	}
</script>

<style lang="scss" scoped>
	.container {
		padding:40px 70px;
		background: #F6F7FA;

		.wrap {
			padding:40px 70px;
			background: white;
			border-radius: 10px;
			.header {
				font-size: 16px;
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #000000;
				padding:20px 0;
			}

			.title {
				font-size: 40px;
				font-weight: bold;
				color: black;
				padding: 60px 0;
				text-align: center;
			}

			.table {
				margin-top: 10px;
				border-radius: 10px;
				background: white;
				.th {
					display: flex;
					flex-wrap: nowrap;
					line-height: 52px;
					text-align: center;
					background: #F6F7FA;
					border-radius: 5px 5px 0px 0px;
					border: 1px solid #E3E3E3;
					color: #575859;
					font-size: 14px;
					.alias {
						width: 190px;
					}
					.info {
						width: 480px;
					}
					.width {
						width: 190px;
					}
					.component {
						width: 190px;
					}
					.desc {
						width: 300px;
					}
					.size {
						width: 220px;
					}

				}
				.td {
					display: flex;
					flex-wrap: nowrap;
					text-align: center;
					border: 1px solid #E3E3E3;
					.info {
						position: relative;
						width: 480px;
						height: 110px;
						border-right: 1px solid #E3E3E3;
						.image {
							position: absolute;
							top: 20px;
							left: 20px;
							width: 68px;
							height: 68px;
							object-fit: cover;
						}
						.name {
							position: absolute;
							top: 34px;
							left: 150px;
							color: #191A1C;
							font-size: 14px;
							font-weight: 500;
						}
					}
					.alias {
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						align-content: center;
						justify-content: center;
						width: 190px;
						height: 110px;
						border-right: 1px solid #E3E3E3;

					}
					.width {
						width: 190px;
						height: 110px;
						line-height: 110px;
						border-right: 1px solid #E3E3E3;
					}
					.component {
						width: 190px;
						height: 110px;
						line-height: 110px;
						border-right: 1px solid #E3E3E3;
					}
					.desc {
						width: 300px;
						height: 110px;
						line-height: 110px;
						border-right: 1px solid #E3E3E3;
						font-weight: bold;
						font-size: 14px;
					}

					.size {
						width: 220px;
						height: 110px;
						line-height: 110px;
						border-right: 1px solid #E3E3E3;
						font-weight: bold;
						font-size: 14px;
					}
				}
			}
		}
		.tip {
			color: #FA3D5A;
			padding:20px 0;
		}
		.btn-print {
			margin: 0 auto;
			width: 180px;
			height: 45px;
			line-height: 45px;
			background: #FA3D5A;
			border-radius: 23px 23px 23px 23px;
			border: 1px solid #FA3D5A;
			color: white;
			text-align: center;
			cursor: pointer;
		}
	}

</style>
